import MapDrawComponent from "./MapDrawComponent";

function App() {
  return (
    <div className="App">
      <h1 className="text-2xl font-bold text-center my-4">
        Maplibre-Gl-Multiple-Color-Draw Demo
      </h1>
      <MapDrawComponent />
    </div>
  );
}

export default App;
